import React from 'react'
import InfoTooltip from 'images/BlueInformationToolTip.svg'
import './index.styl'

const PublishInfoBox = () => {
  return (
    <div className='publishInfoBox'>
      <div className='publishInfoBoxTitle'>
        <img alt='InfoTooltip' src={InfoTooltip} className='publishInfoBoxIcon' />
        Before You Publish Your Event
      </div>
      <p>Please review your event details carefully before continuing. Once tickets have been sold, some information may be restricted or require approval before it can be changed.</p>
      <p>Make sure your event name, date, time, location, ticket pricing, and media accurately represent your event. Incorrect information may confuse attendees and could impact ticket sales.</p>
      <p>By publishing this event, you confirm that you have the necessary rights to organize and promote it, and that all provided information is accurate and complies with Ticket Lyfe's Terms of Service.</p>
    </div>
  )
}

export default PublishInfoBox
